import moment from 'moment';
import 'moment/locale/pt-br';

export default {
  diffInDays(initialDate, finalDate) {
    return moment(finalDate).startOf('day').diff(moment(initialDate).startOf('day'), 'days');
  },
  diffInHours(initialDate, finalDate) {
    return moment(finalDate).diff(moment(initialDate), 'hours');
  },
};
